import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import apiClient from '../../../services/apiClient';

const VARIABLES = ['{nombre}', '{fecha}', '{lugar}', '{horaCitacion}', '{horaJunta}', '{horaPericia}'];

const PLANTILLAS = [
  { key: 'juntaMedicaConCitacion', label: 'Junta médica con citación al estudio', hora: '{horaJunta}' },
  { key: 'periciaConCitacion', label: 'Pericia con citación al estudio', hora: '{horaPericia}' },
];

const ejemplo = (texto) => (texto || '')
  .replace(/\{nombre\}/g, 'Juan García')
  .replace(/\{fecha\}/g, '12/05/2026')
  .replace(/\{lugar\}/g, 'UDAI Centro')
  .replace(/\{horaCitacion\}|\{hora\}/g, '10:00')
  .replace(/\{horaJunta\}|\{horaPericia\}/g, '11:00');

/**
 * Las plantillas del recordatorio de junta médica y pericia cuando el cliente está citado en el
 * estudio (V254). Se usan en vez de las de "Junta Médica" / "Pericia Médica" de arriba solo si la
 * junta o pericia tiene una citación vigente en el turnero. Se guardan en el sistema (no en el
 * servicio de WhatsApp), por eso tienen su propio botón.
 */
export default function PlantillasCitacion() {
  const [plantillas, setPlantillas] = useState(null);
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    apiClient.get('/configuracion/plantillas-citacion')
      .then(({ data }) => setPlantillas(data))
      .catch(() => setPlantillas({}));
  }, []);

  const guardar = async () => {
    setGuardando(true);
    try {
      const { data } = await apiClient.put('/configuracion/plantillas-citacion', plantillas);
      setPlantillas(data);
      toast.success('Plantillas de citación guardadas.');
    } catch (err) {
      toast.error(err.response?.status === 403 ? 'No tenés permiso para cambiar las plantillas.' : 'No se pudieron guardar.');
    } finally {
      setGuardando(false);
    }
  };

  if (!plantillas) return null;
  return (
    <div className="card shadow-sm border-0 rounded-4 p-4" style={{ gridColumn: '1 / -1' }}>
      <h5 className="fw-semibold mb-1"><i className="bi bi-calendar-check me-2" />Junta y pericia con citación al estudio</h5>
      <p className="text-muted small mb-3">
        Se usan cuando la junta o la pericia tiene una citación en el turnero. Variables:{' '}
        {VARIABLES.map((v) => <code key={v} className="me-2">{v}</code>)}
      </p>
      {PLANTILLAS.map((p) => (
        <div key={p.key} className="mb-3">
          <label className="form-label fw-semibold">{p.label}</label>
          <textarea
            className="form-control" rows={3} value={plantillas[p.key] || ''}
            onChange={(e) => setPlantillas({ ...plantillas, [p.key]: e.target.value })}
          />
          <div className="small mt-1" style={{ color: '#374151' }}>
            <strong>Ejemplo:</strong> {ejemplo(plantillas[p.key])}
          </div>
        </div>
      ))}
      <div>
        <button type="button" className="btn btn-primary" disabled={guardando} onClick={guardar}>
          {guardando ? 'Guardando…' : 'Guardar plantillas de citación'}
        </button>
      </div>
    </div>
  );
}
